module.exports = __webpack_public_path__ + "img/contact-request-sent-thank-you-th.396e001.png";